// @ actions
const { validateAndExecute } = require('actions/signaturePattern');

// @ utilities
const get = require('lodash/object/get');
const { APIPost } = require('utilities/APIRequestHelper');
const { getPhoneById } = require('utilities/contactCenter/modifyMainPhoneHelper');

const {
    CONFIRM_MODIFY_MAIN_PHONE_REQUEST,
    CONFIRM_MODIFY_MAIN_PHONE_SUCCESS,
    CONFIRM_MODIFY_MAIN_PHONE_FAILURE,

    MODIFY_MAIN_PHONE_RESET,
    MODIFY_MAIN_PHONE_SET_VISIBLE_STEP,
    MODIFY_MAIN_PHONE_VALIDATE,
    MODIFY_MAIN_PHONE_SHOW_CANCEL_MODAL,

    CONTACT_PHONE_DATA_REQUEST,
    CONTACT_PHONE_DATA_SUCCESS,
    CONTACT_PHONE_DATA_FAILURE,

    SET_MAIN_PHONE
} = require('constants/contactCenter/actionTypes');

const { SUCCESS_CODE } = require('constants/contactCenter/modifyMainPhone');

const { FIRST_STEP } = require('constants/index');

const confirmModifyMainPhoneInProgress = () => ({
    type: CONFIRM_MODIFY_MAIN_PHONE_REQUEST
});

const confirmModifyMainPhoneSuccess = () => ({
    type: CONFIRM_MODIFY_MAIN_PHONE_SUCCESS
});

const confirmModifyMainPhoneFailure = error => ({
    type: CONFIRM_MODIFY_MAIN_PHONE_FAILURE,
    payload: {
        error
    }
});

const contactPhoneDataInProgress = () => ({
    type: CONTACT_PHONE_DATA_REQUEST
});

const contactPhoneDataSuccess = payload => ({
    type: CONTACT_PHONE_DATA_SUCCESS,
    payload
});

const contactPhoneDataFailure = error => ({
    type: CONTACT_PHONE_DATA_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: MODIFY_MAIN_PHONE_RESET
});

const setVisibleStep = step => ({
    type: MODIFY_MAIN_PHONE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const showCancelModal = (show) => ({
    type: MODIFY_MAIN_PHONE_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const validateStep = step => ({
    type: MODIFY_MAIN_PHONE_VALIDATE,
    payload: {
        step
    }
});

const setMainPhone = (deviceNumber) => ({
    type: SET_MAIN_PHONE,
    payload: Number(deviceNumber)
})

const requestContactPhoneData = () => (dispatch) => {
    const params = {
        query: {
            tipoConsulta: '1',
            tipoDispositivo: 'T '
        }
    };

    dispatch(contactPhoneDataInProgress());

    return APIPost({ dispatch, endpoint: 'userProfileDevices', params})
        .then((response) => dispatch(contactPhoneDataSuccess(response)))
        .catch((error) => dispatch(contactPhoneDataFailure(error)))
};

const confirmModifyMainPhoneRequest = (dataToken) => (dispatch, getState) => {
    const { modifyMainPhone: immModifyMainPhone } = getState();
    const phonesList = immModifyMainPhone.getIn(['mainContactPhoneData', 'listaDispositivos']).toJS();
    const selectedPhoneId = immModifyMainPhone.getIn(['steps', FIRST_STEP, 'selectedPhoneId']);
    const selectedDevice = getPhoneById(phonesList, selectedPhoneId);
    delete selectedDevice.preferente;
    delete selectedDevice.tipoDeDispositivo;
    const params = {
        query: {
            preferedDevice: {
                ...selectedDevice,
                tipoDispositivo: "T ",
                indPreferente: "S"
            },
            token: dataToken
        }
    }

    if (!immModifyMainPhone.get('isFetching')) {
        dispatch(confirmModifyMainPhoneInProgress());

        return APIPost({dispatch, endpoint: 'userProfileModify', params})
            .then((response) => {
                const returnCode = get(response, 'listaRetorno.registroRetorno[0].codigoRetorno');

                if (returnCode !== SUCCESS_CODE) {
                    return dispatch(confirmModifyMainPhoneFailure(returnCode));
                }

                return dispatch(confirmModifyMainPhoneSuccess(response));
            })
            .catch((error) => dispatch(confirmModifyMainPhoneFailure(error)))
    }
};

const confirmModifyMainPhone = () => (dispatch, getState) => {
    validateAndExecute(dispatch, getState, (dispatch, getState, dataToken) => {
        dispatch(confirmModifyMainPhoneRequest(dataToken));
    });
}

module.exports = {
    confirmModifyMainPhone,
    requestContactPhoneData,
    setMainPhone,
    setVisibleStep,
    validateStep,
    showCancelModal,
    reset
};
